import type React from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router"

import { PageHeaderNavigation } from "@/components/nav/page-header-navigation"
import { SitePath } from "@/models/route"
import { useFlags } from "@/services/feature"
import { useUrl } from "@/utils/url"

import { Tab, Tabs } from "@mui/material"

export const SitesIndexNavigation: React.FC = () => {
  const { t } = useTranslation("sites")
  const flags = useFlags()
  const { buildSitesUrl } = useUrl()
  const { pathname } = useLocation()

  return (
    <PageHeaderNavigation>
      {/* MUI 6 does not put aria-label on <nav> element */}
      {/* So must use it manually */}
      <nav aria-label={t("tab.label")}>
        <Tabs sx={{ px: 3 }} value={pathname}>
          <Tab
            component={Link}
            label={t("tab.overview")}
            to={SitePath.Overview}
            value={buildSitesUrl(SitePath.Overview)}
          />
          <Tab
            component={Link}
            label={t("tab.performance")}
            to={SitePath.Performance}
            value={buildSitesUrl(SitePath.Performance)}
          />
          {flags.sites_compliance && (
            <Tab
              component={Link}
              label={t("tab.compliance")}
              to={SitePath.Compliance}
              value={buildSitesUrl(SitePath.Compliance)}
            />
          )}
        </Tabs>
      </nav>
    </PageHeaderNavigation>
  )
}
